import {USER_SET_TAB_BAR_POSITION} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import saveCfgItem from '~/frontend/src/actions/user/saveCfgItem';
import loadCfgItem from '~/frontend/src/actions/user/loadCfgItem';

export type TabBarPosition = 'horizontal' | 'vertical';

/**
 * @memberOf! Actions
 *
 * @param {string} tabBarPosition
 *
 * @return {}
 */
const setTabBarPosition = ( tabBarPosition : TabBarPosition ) : Thunk<Promise<void>> => async ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: USER_SET_TAB_BAR_POSITION,
        tabBarPosition
    } );

    const user = getState().session.user;

    if ( user ) {
        user.tabBarPosition = tabBarPosition;

        if ( await dispatch( saveCfgItem( 'noMask' ) ) ) {
            await dispatch( loadCfgItem( 'noMask' ) );
        }
    }
}

export type SetTabBarPosition = typeof setTabBarPosition;

export default setTabBarPosition;
